import { Text } from '@/components/shared/components/Text';

export enum InclusionFilter {
  WITH = 'WITH',
  WITHOUT = 'WITHOUT',
  ALL = 'ALL',
}

export const InclusionFilterMultiSelectOptions = (variable?: string) => [
  {
    value: InclusionFilter.ALL,
    display: <Text tId={InclusionFilter.ALL} />,
  },
  {
    value: InclusionFilter.WITH,
    display: <Text tId={variable ? `WITH_${variable}` : InclusionFilter.WITH} />,
  },
  {
    value: InclusionFilter.WITHOUT,
    display: <Text tId={variable ? `WITHOUT_${variable}` : InclusionFilter.WITHOUT} />,
  },
];
